export const LOAD_ADD_TO_CALENDAR_PROVIDERS =
  'event-guestside-site/calendar/LOAD_CALENDAR_PROVIDERS';

export function setAddToCalendarProviders(calendarProviders) {
  return {
    type: LOAD_ADD_TO_CALENDAR_PROVIDERS,
    payload: { calendarProviders }
  };
}

export const loadAddToCalendarProviders = () => async (dispatch, getState) => {
  const {
    clients: { lookupClient },
    accessToken,
    addToCalendar
  } = getState();
  if (!(addToCalendar && Object.keys(addToCalendar).length > 0)) {
    const addToCalendarProvidersResponse = await lookupClient.getCalendarProviders(
      accessToken
    );
    const { calendarProviders } = addToCalendarProvidersResponse;
    dispatch(setAddToCalendarProviders(calendarProviders));
  }
};

export default function addToCalendarReducer(state = {}, action) {
  switch (action.type) {
    case LOAD_ADD_TO_CALENDAR_PROVIDERS: {
      return {
        ...state,
        ...action.payload.calendarProviders
      };
    }
    default: {
      return state;
    }
  }
}
